
// Patient Details
const  RETAIL_REQUEST = 'RETAIL_REQUEST';
const  RETAIL_SUCCESS = 'RETAIL_SUCCESS';
const  RETAIL_FAILURE = 'RETAIL_FAILURE';

//retail
const RETAIL_PHARMACY_REQUEST = 'RETAIL_PHARMACY_REQUEST';
const RETAIL_PHARMACY_SUCCESS = 'RETAIL_PHARMACY_SUCCESS';
const RETAIL_PHARMACY_FAILURE = 'REATIL_PHARMACY_FAILURE';

// PHARMACY Getby Id
const RETAIL_REQUEST_GETBYID = 'RETAIL_REQUEST_GETBYID';
const RETAIL_SUCCESS_GETBYID = 'RETAIL_SUCCESS_GETBYID';
const RETAIL_FAILURE_GETBYID = 'RETAIL_FAILURE_GETBYID';

//UPDATE
const RETAIL_REQUEST_UPDATE = 'RETAIL_REQUEST_UPDATE';
const RETAIL_SUCCESS_UPDATE = 'RETAIL_SUCCESS_UPDATE';
const RETAIL_FAILURE_UPDATE = 'RETAIL_FAILURE_UPDATE';

// Pharmacy Create
const RETAIL_REQUEST_CREATE = 'RETAIL_REQUEST_CREATE';
const RETAIL_SUCCESS_CREATE = 'RETAIL_SUCCESS_CREATE';
const RETAIL_FAILURE_CREATE = 'RETAIL_FAILURE_CREATE';
export {
    RETAIL_REQUEST,
    RETAIL_SUCCESS,
    RETAIL_FAILURE,
    RETAIL_PHARMACY_REQUEST,
    RETAIL_PHARMACY_SUCCESS,
    RETAIL_PHARMACY_FAILURE,
    RETAIL_REQUEST_GETBYID,
    RETAIL_SUCCESS_GETBYID,
    RETAIL_FAILURE_GETBYID,
    RETAIL_REQUEST_UPDATE,
    RETAIL_SUCCESS_UPDATE,
    RETAIL_FAILURE_UPDATE,
    RETAIL_REQUEST_CREATE,
    RETAIL_SUCCESS_CREATE,
    RETAIL_FAILURE_CREATE
};
